<template>
    <v-card
        class="elevation-4 mx-auto"
        width="650"
    >
        <v-card-title
            class="py-2 pl-8 caption white--text font-weight-light text-uppercase primary"
        >
            <v-spacer></v-spacer>
                <span>End of Term Reports</span>
            <v-spacer></v-spacer>
        </v-card-title>
        <v-row class="pa-4">
            <v-col>
                <v-list>
                    
                    <v-list-item-group v-model="menu">
                        <v-list-item
                            v-for="(item, i) in items"
                            :key="i"
                            @click="selectOption(item)"
                        >
                            <v-list-item-icon>
                                <v-icon 
                                    color="primary"
                                >
                                    {{ item.icon }}
                                </v-icon>
                            </v-list-item-icon>
                            <v-list-item-content>
                                <v-list-item-title 
                                    :class="fontClass"
                                >
                                    {{ item.text }}
                                </v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                    </v-list-item-group>
                </v-list>
            </v-col>
            <v-col>
                    <v-img
                    src="../assets/logo.png"
                    max-width="120"
                    contain
                    class="d-flex"
                ></v-img> 
            </v-col>
        </v-row>
    </v-card>    
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex';
export default {
    name: 'MainMenu',
    data: () => ({
        items: [
            {
                icon: 'mdi-keyboard',
                text: 'Enter Marks (Subject Teachers)',
                menu: 'enter-marks',
            },
            {
                icon: 'mdi-pencil',
                text: 'Edit/View Term Details (Form Teachers)',
                menu: 'term-details',
            },
            {
                icon: 'mdi-notebook-edit',
                text: 'Mark Book',
                menu: 'mark-book'
            } 
        ],
        menu: '',  
    }),
    computed: {
        ...mapGetters({
            user: 'auth/getEmployeeSignedIn',
            primaryColor: 'termReports/getPrimaryColor',
            colorDarken: 'termReports/getColorDarken',
            getMarkSheetLoading: 'termReports/getMarkSheetLoading',
            getEditViewTermReportsOverlay: 'termReports/getEditViewTermReportsOverlay',            
            id: 'auth/getEmployeeId',
        }),
       
       
        cardTitleClass(){
            return 'py-2 pl-8 caption white--text font-weight-light text-uppercase primary';
        },
        fontClass(){
            return 'font-weight-normal text-uppercase primary--text ';
        }
    },
   
    methods: {
        ...mapMutations({
            setMainMenu: 'termReports/setMainMenu',
            setEnterMarks: 'termReports/setEnterMarks',
            setEditViewTermReports: 'termReports/setEditViewTermReports',
            editViewTermReportsOverlay: 'termReports/setEditViewTermReportsOverlay',
            editViewTermReportsLoading: 'termReports/setEditViewTermReportsLoading',
            formClasses: 'termReports/setFormClasses',
            setFormTeacherClass: 'termReports/setFormTeacherClass',
            setMainMenuButton: 'termReports/setMainMenuButton',  
            setMarkBook: 'markBook/setMarkBook',          
        }),
        ...mapActions({
            getFormClasses: 'termReports/getFormClasses',
            getFormTeacherClass: 'termReports/getAssignedFormTeacherClass',  
        }),

        selectOption ({ menu }) {
            this.setMainMenuButton(true); 
            this.setMainMenu(false);
            this.displayMenuComponent(menu);

            if(menu === 'term-details'){
                this.editViewTermReportsOverlay(true);
                this.editViewTermReportsLoading(true);
                this.setFormClases(); 
            }            
        },

        displayMenuComponent (menu) {
            // console.log('menu:', menu);
            let menuItems = {
                'enter-marks' : this.setEnterMarks,
                'term-details' : this.setEditViewTermReports,
                'mark-book' : this.setMarkBook
            }
            Object.keys(menuItems).forEach(key => {
                menuItems[key](false);
                if(key === menu){
                    menuItems[key](true)
                }
            })
        },

        async setFormClases(){
            const { data: dataFormTeacherClass } = await this.getFormTeacherClass(this.id);
            //console.log(response);
            this.setFormTeacherClass('');
            if(dataFormTeacherClass.length > 0) this.setFormTeacherClass(dataFormTeacherClass[0].class_id);
            const { data: dataFormClasses } = await this.getFormClasses();
            //console.log(response);
            let formClasses = [];
            let form1Classes = [];
            let form2Classes = [];
            let form3Classes = [];
            let form4Classes = [];
            let form5Classes = [];
            let form6Classes = [];            
            dataFormClasses.forEach(record => {
                switch(record.form_level){
                    case 1:
                    form1Classes.push({
                        title: record.class_id
                    });
                    break;
                    case 2:
                    form2Classes.push({
                        title: record.class_id
                    });
                    break;
                    case 3:
                    form3Classes.push({
                        title: record.class_id
                    });
                    break;
                    case 4:
                    form4Classes.push({
                        title: record.class_id
                    });
                    break;
                    case 5:
                    form5Classes.push({
                        title: record.class_id
                    });
                    break;
                    case 6:
                    form6Classes.push({
                        title: record.class_id
                    });
                    break;
                }                
            });
            formClasses.push({
                title: 'Form 1',
                action: 'mdi-school',                
                items: form1Classes
            });
            formClasses.push({
                title: 'Form 2',
                action: 'mdi-school',                
                items: form2Classes
            });
            formClasses.push({
                title: 'Form 3',
                action: 'mdi-school',                
                items: form3Classes
            });
            formClasses.push({
                title: 'Form 4',
                action: 'mdi-school',                
                items: form4Classes
            });
            formClasses.push({
                title: 'Form 5',
                action: 'mdi-school',                
                items: form5Classes
            });
            formClasses.push({
                title: 'Form 6',
                action: 'mdi-school',                
                items: form6Classes
            });            
            this.formClasses(formClasses);
        }
    }
}
</script>